import React from 'react'
import Match_Odds from './Match_Odds'
export const NepalPreLeague = () => {
  return (
    <div className='wbb-container'>
      <div
      className="wbb-title"
          style={{ backgroundColor: "#441010ff", height: "150px" }}>
    </div>
    <Match_Odds />
    </div>
    
  )
}
